module.exports = __webpack_public_path__ + "static/media/model-xtrail-t31.bb673894.jpg";